import { useCurrentUser } from '@qualio/ui-components';
import { useQuery, useQueryClient } from 'react-query';
import templateApi, { Template } from '../api/templateApi';

type UseTemplatesProps = {
  includeArchived: boolean;
};

export const templatesQueryKey = (companyId: number) => [
  'templates',
  companyId,
];

export const useInvalidateTemplates = (companyId: number) => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries(templatesQueryKey(companyId));
};

export const useTemplates = ({ includeArchived }: UseTemplatesProps) => {
  const currentUser = useCurrentUser();
  const fetchTemplates = async (): Promise<Template[]> => {
    if (includeArchived) {
      return templateApi.getAllTemplatesV2(currentUser.companyId);
    }
    const getTemplatesFn = templateApi.getTemplates;
    return getTemplatesFn(currentUser.companyId);
  };

  return useQuery({
    queryFn: fetchTemplates,
    queryKey: templatesQueryKey(currentUser.companyId),
    refetchOnWindowFocus: false,
  });
};
